module.exports = __webpack_public_path__ + "static/media/purchaseOption-digitalJournal.44477864.svg";